import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./authSlice";
import uiReducer from "./uiSlice";
import unitReducer from "./unitSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    unit: unitReducer,
    ui: uiReducer,
  },
});
